export const PaymentResources = {
    es: {
        ['checkin']: 'Retención',
        ['payment']: 'Pago',
        ['checkin_for_your_rent']: 'Retención por tu renta',
        ['checkin_for_your_rent_description']: 'Se tomará de tu tarjeta de crédito y cuando devuelvas el auto se liberará dicha cantidad',
        ['pay_with_card']: 'Paga con tu tarjeta',
        ['pay_with_card_description']: 'El nombre en la tarjeta debe ser el mismo que el nombre de quien renta el auto',
        ['read_your_agreement']: 'Lee tu contrato, en él se establece todos los terminos y condiciones. Fírmalo con tu firma autógrafa para finalizar tu renta',
        ['hold_visa']: 'Retención con Visa',
        ['hold_mastercard']: 'Retención con Mastercard',
        ['hold_american_express']: 'Retención con American Express',
        ['choose_payment_method']: 'Elige un método de pago',
        ['debit_card']: 'Tarjeta de débito',
        ['credit_card']: 'Tarjeta de crédito',
        ['insert_card']: 'Inserte, deslice o acerque su tarjeta',
        ['payment_success']: '¡Pago Exitoso!',
        ['payment_successful_processed']: 'Tu pago ha sido procesado exitosamente.',

        ['auth_code']: 'Código de autorización',
        ['psp_reference']: 'Referencia PSP',
        ['date']: 'Fecha',
        ['amount']: 'Monto',
        ['amount_due']: 'Total a pagar',
        ['tap_to_pay']: 'Toca para pagar',
        ['payment_error']: 'Error de pago',
        ['try_again_or_counter']: 'Vuelva intentar o acuda a mostrador',
    },
    en: {
        ['checkin']: 'Checkin',
        ['payment']: 'Payment',
        ['checkin_for_your_rent']: 'Checkin for your Rent',
        ['checkin_for_your_rent_description']: 'It will be taken from your credit card and will be released when you return the car',
        ['pay_with_card']: 'Pay with your card',
        ['pay_with_card_description']: 'The name on the card must be the same as the name of the person renting the car',
        ['read_your_agreement']: 'Read your agreement; it establishes all the terms and conditions. Sign it with your handwritten signature to finalize your rental',
        ['hold_visa']: 'Hold with Visa',
        ['hold_mastercard']: 'Hold with Mastercard',
        ['hold_american_express']: 'Hold with American Express',
        ['choose_payment_method']: 'Choose a payment method',
        ['debit_card']: 'Debit Card',
        ['credit_card']: 'Credit Card',
        ['insert_card']: 'Please insert, swipe or tap card',
        ['payment_success']: 'Payment Successful!',
        ['payment_successful_processed']: 'Your payment has been processed successfully.',

        ['auth_code']: 'Authorization Code',
        ['psp_reference']: 'PSP Reference',
        ['date']: 'Date',
        ['amount']: 'Amount',
        ['amount_due']: 'Amount Due',
        ['tap_to_pay']: 'Tap to pay',
        ['payment_error']: 'Payment Error',
        ['try_again_or_counter']: 'Try again or proceed to the counter.',
    }
}
